import { z } from 'zod';

export const LanguageCode = z.enum(['fr', 'en']);

export type LanguageCodeT = z.infer<typeof LanguageCode>;
